"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_sms__text(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "a917ae70-55b1-48c9-88d3-b507a49cd2f5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1d31503e-1f4c-4f7b-a2fd-28e60b125cbb",
    "data-name": "1d31503e-1f4c-4f7b-a2fd-28e60b125cbb"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5,109.75",
    style: {
      fill: "none",
      stroke: "#fecb00",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,110H60.24L37.88,134V110H32A14,14,0,0,1,18,96V56A14,14,0,0,1,32,42h72a14,14,0,0,1,14,14h0V78",
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,150l24.12,24V150H160a14,14,0,0,0,14-14V92a14,14,0,0,0-14-14H88A14,14,0,0,0,74,92v44a14,14,0,0,0,14,14Z",
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "_339a09e0-6895-4d28-bbdc-9893e27b5c09",
    "data-name": "339a09e0-6895-4d28-bbdc-9893e27b5c09",
    x1: 150,
    y1: 102,
    x2: 98,
    y2: 102,
    style: {
      fill: "none",
      stroke: "#e60000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "_709f6f25-5f90-4e0a-b5f8-4f984826fe57",
    "data-name": "709f6f25-5f90-4e0a-b5f8-4f984826fe57",
    x1: 150,
    y1: 126,
    x2: 98,
    y2: 126,
    style: {
      fill: "none",
      stroke: "#e60000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }))));
}

var _default = ic_sms__text;
exports.default = _default;